// extracted by mini-css-extract-plugin
export default {"leftNav":"LeftNav_leftNav__EBRSC"};